export default {
  headContent: {
    title: 'JDC',
    subTitle: 'Academic Journal Big Data'
  },
  navigateBar: {
    home: 'Home',
    productService: 'Product&Service',
    openData: 'Open Data',
    blog: 'Blog',
    contactUs: 'Contact Us',
    ojsSupport:'OJS Support',
    updatedJournalLists: 'Updated Journal Lists',
    dynamicJournalImpactFactor: 'Dynamic Journal ImpactFactor',
    impactFactorManagment: 'Impact Factor Managment',
    journalEvaluationManagement: 'Journal Evaluation Management',
    qualifiedAuthorTargeting: 'Qualified Author Targeting'
  },
  bottomContent: {
    contactEmail: 'Contact E-mail：',
    backContent: 'Talk to our team to learn how My Organization can support your institution.',
  },
  index:{
    first:{
      title:'<span>Pre-Evaluation</span> of Scientific Journals Applying<br>for Scopus SClIndexing',
      contactBtn:'Contact Us'
    },
    second:{
      title:'Tools of Journal lmpact Enhancement',
      leftTitle:'',
      rightTitle:'',
      leftContent1: 'Real-time reference tracking rendering',
      leftContent2:'Algorithm-driven accurate recommendation of relevant papers',
      leftContent3:'Rich and in-depth journal analysis data',
      leftContent4:'A connected window to thousands of high-quality academic articles',      
      rightContent:'A content-driven tool using academic paper algorithms to dynamically recommend reading from an earlier stage. The recommended articles changes dynamically when visited, enabling the interconnection among papers.<brTrendMD boosts article exposure and reading volume by its paid promotion services.',
      btnText:'Apply for Trial' 
    },
    third:{
      title:'The "24 + 4" Criterion: The Gold Standard for Journals indexed by Clarivate',
    },
    fourth:{
      title:'Industry Trends',
      btnText:'Read More',
      noData:'No Data',
      tab1:'Dynamics',
      tab2:'Index Pre-Evaluation',
      tab3:'Successful Case',
      tab4:'Guidance',
    },
    sixth:{
      title:'Open Data',
      subTitle:'Includes: Updated Journal Lists | Dynamic Journal Impact Factor | Journal in Warning',
      content1li1:'Updated Journal Lists',
      content1li2:'Dynamic Journallmpact Factor',
      content1li3:'Journal in warning',
      title2:'Open Sciences Members'
    },
	seventh:{
		title:'Learn more about Contrimetric Plugin',
		emptyInfo:'Your browser does not support the video tag.'
	}
    
  },

  blog: {
    title: 'Blog',
    keyWord: 'KeyWord',
    readAll: 'Read All'
  },
  aboutUs: {
    title: 'Contact Us',
    reply:'Please leave your information, our staff will reply you within 1-3 working days after receiving your email.',
    contact_info1:'Journal Academy: Professional public account for academic journal publishing consultation.',
    contact_info2:'Academic Journal Big Data Service Platform.',
    contact_info3:'Consulting Services: Instruction on Journal Management; Academic Intelligence; Journal Evaluation; Journal Mergers and Acquisitions.',
    contact_info4:'Technical Services: Journal Influence Enhancement; Journal Impact Factor Management;',
    contact_info5:'Professional Services: ESCI Promotion to SCI; General Journals Selected into SCI; General Journals Selected into ESCI; General Journals Selected into Scopus.',
    contact_info6:'Look forward to your enquiry'
  },
  formAbout: {
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    message: 'Your message',
    submit: 'Submit'
  },
  formRules: {
    name: 'Please enter your name',
    email: 'Please enter email',
    emailFormat:'Please enter correct email format',
    phone: 'Please enter phone number',
    phoneFormat:'Please enter correct phone format',
    message: 'Please enter a message',
    phoneEmail:'Please enter your phone or email address',
    phoneEmailFormat: 'Please enter the correct phone or email format',
    nameFormat: 'The contact name should be between 2 and 20 characters long',
  },
  jem:{
    title: 'Journal Evaluation and Management',
    subTitle:'Journal Quality Evaluation',
    subTitle1:'Academic Intelligence',
    subTitle2:'Talent Evaluation and Managment',
    subTitle3:'Collaboration for Development',
    subTitle4:'Effective Indexing Process',
    content:"Hot topics, frontiers, and emerging scientific issues are the way forward pursued and worked for by countless scholars. If the research topics of the papers published in the journal that coincide with current academic hot topics and international frontiers, this will greatly enhance the journal's academic impact, and help it develop into an international first-class journal.",
    content1:'Editorial Board and reviewer, as the important parts of journal’s core competence, are a“goalkeepers” of journals leading the publication direction and academic quality. The basic constructions and compositions of Editorial board and reviewers should be well designed for sustainable development. It’s necessary to build a practical editorial board if an emerging journal wants to promote its impact. Also the editorial board needs to make use of its academic and communication advantages to lay the foundation for the rapid development of journal.',
    content2:'JDC currently publishes approximately 50 journals owned by universities and other instituions. Many of them are indexed by Clarivate Web of Science, Scopus, COMPENDEX and PubMed with some enjoying high impact factors.',
    firstLi1:"Track the journal's progress towards peer review system and academic intergrity",
    firstLi2:'Analyze Citation Network of each published paper contributed to the journal',
    secondLi1:'Evaluate the published papers and compare with research results released by top journals within the same field',
    secondLi2:'Learn about how the journal locate the hot topics and fronitiers',
    secondLi3:'Gain from the hot topics and fronitiers',
    thirdLi1:'Assess the academic network of Editorial Board members and learn about how they contribute to journal performance and development',
    thirdLi2:'Complie multipe quantative research perfomance indicators for individuals and teams, to make the complement of qualitative assessment',
    thirdLi3:'Invite experts as the key option leaders to build the fame',
    thirdLi4:'Socialize with more potential reviewer and build strong social networks',
    thirdLi5:'Increase the visibility and recognition of peer reviewers',
    fourthLi1:'Match the most valuable publisher for the journal',
    fourthLi2:'Find the right academic, university and corporate partners',
    fourthLi3:'Foster transdisciplinary collaborations and make connections with other journals',
    fourthLi4:'Seek sponsership to enlarge journal impact',
    fifthLi1:'Analyze the Indexing standards and criteria',
    fifthLi2:'Cultivate journals till they are indexed by target databases',
    fifthLi3:'Simulation evaluation of journals before submission',
    application:'Apply for Trial',
    bottomText:'Publishers & University&Association',
    bottomText1:'Publishers',
    bottomText2:'University&Association',
  },
  ifm:{
    title: 'Impact Factor Managment',
    subTitle: 'Impact factor is one of the most objectively indicator reflecting the quality of journals. Steady improvment of journal impact factor is a long term target for all journals that have been included by SCIE/SSCI.',
    subTitle1:'JIF Calculator: ',
    subTitle4:'IF(2024)=Citation from all DT in 2024/ Number of (A+R)Publication in 2022 & 2023',
    contentTitle1:'Journal Impact Factor Estimation',
    contentTitle2:'Avoiding Citation Traps',
    contentTitle3:'Increase JIF and JCR Ranking',
    contentFirstLi1:'Journal Impact Factor Estimation',
    contentFirstLi2:'Citation Resouces Distribution, including geographical distribution, publisher distribution and so on',
    contentSecondLi1:'Decrease the risk of Stacking Citation',
    contentThirdli1:'Performance analysis report of journals in the same discipline',
    contentThirdli2:'Promote and publish papers to research teams at home and abroad for conversion into valid citations',
  },
  qat:{
    title: "Qualified Author Targeting",
    subTitle:'Big Data Accurate Matching',
    li1:'Establish Databases/Lists on Target Clients',
    li2:'"Call for Paper"Personalized Customization',
    li3:'Feedback Recivingand Unsubcription System',
    li4:'Data Cleaning toMake Accurate Lists',
    li5:'Journal Promotion toInterested Clients',
    content:'Media Pull',
    content2:'Connect with your clients in Facebook, Twitter, instagram....'
  },
  journalLi:{
    title:'Updated Journal Lists',
    year:'Year',
    type:'Type',
    all:'All',
    exclude:'Exclude',
    search:'Search',
    apply:'Apply',
    cancel:'Cancel',
    reset:'Reset',
    searchResults:'Search results: Papers found for you',
    item:'items',
    journalStatus:'Journal Status',
    searchType:'Search Types',
    month:'Month',
    literature:{
      journalName:'JournalName',
      issn:'ISSN',
      year:'Year',
    },
    literatureRules:{
      issn:'Please enter ISSN',
      year:'Please enter the year',
      journalName:'Please enter the journal name',
    },
    choice:'Please Select',
    generalSearch:'General Search',
    advancedSearch:'Advanced Search',
    defaultPlaceholder: 'Please enter content',
    cancelSelect:'Please select the item to cancel first',
    excludeSelect:'The selected item is already in the exclusion list, please cancel the exclusion first',
    applySelect:'The selected item is already in the application list, please cancel the application first',
  },
  djif:{
    title:'Dynamic-Journal-Impact-Factor',
    description:'No Data',

  },
  journalDe:{
    issn:'ISSN:',
    eissn:'e-ISSN:',
    detail:'Detail:',
    brief:'Breif:',
    publisher:'Publisher:',
    jci:'JCI:',
    cycle:'Cycle:',
    impactIndex:'Impact Index:',
    country:'Country:',
    yearPulisherCount:'Annual Publication Volume:',
    chineseRate:'Chinese Author Proportion:',
    subject:'Discipline:',
    WhetherLibrary:'In Repository:',
    warning:'CAS Warning:',
    webSite:'Official Website:',
    domesticDivision:'Domestic Partition (Updated Version):',
    bigType:'Category:',
    smallType:'Subcategory:',
    hIndex:'H-Index:',
    citeMySelf:'Self-Citation Rate:',
    isOa:'Is OA:',
    citeScore:'Cite Score:',
    snip:'SNIP:',
    sjr:'SJR:',
    scopusSubject:'Scopus Subject:',
    partition:'partition:',
    rank:'rank:',
    percentage:'percentile:',
    echartTitle:'5-year impact index trend chart'
  },

  applyForm: {
    title: 'Submit Applications',
    journalName: "JournalName",
    issn: "ISSN",
    webSite: "WebSite",
    contact: "Contact",
    contactInformation: "ContactInformation",
    request: "Request",
  },

  form: {
    printBtn: 'print',
    mockBtn: 'mock',
    submitBtn: 'Submit',
    emptyBtn: 'empty'
  },

  paginationText: {
    firstText:'Home Page',
    lastText: 'Trailer Page',
    prevText: 'Previous Page',
    nextText: 'Next Page'
  },

  messagePrompt: {
    success: 'Operate successfully',
    fail: 'Operation failure',
    error: 'system error',
    warning: 'Operating system alert monitor',
    confirm: 'confirm',
    cancel: 'cancel',
    delete: 'delete',
    deleteSuccess: 'Successfully delete',
    deleteFail: 'Fail to delete',
    deleteWarning: 'Delete warning',
    deleteConfirm: 'Are you sure to delete it?',
    deleteCancel: 'Undelete',
    deleteError: 'Delete error',
    noSelect: 'Please select first',
  },

  reCheck: {
    newsTitle:'News',
    newsItemContent:"A one-of-a-kind reference checker! With ReCheck, authors and journals are able to perform an in-depth check on the accuracy, authority, and timeliness of each article's references. This not only helps to improve the quality of published articles, but also significantly improves the journal's overall influence and reputation in the academic community.",
    newsButton:'Read more'
  },
}
